// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
// eslint-disable-next-line no-restricted-imports
import {jsx} from 'panel';
import {VNode} from 'snabbdom';

// eslint-disable-next-line import/no-cycle
import {ReplayPreviewEl} from './index';

export const ReplayPreviewRenderer = (eventName: string): VNode => {
  return <ReplayPreviewEl eventName={eventName} />;
};
